import { render, staticRenderFns } from "./AllergiesList.vue?vue&type=template&id=5cdda71e&"
import script from "./AllergiesList.vue?vue&type=script&lang=js&"
export * from "./AllergiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports